import { z } from 'zod';

import { chatBlockSchema } from './chat-blocks';
import { chatEventIdSchema, chatMessageIdSchema, chatThreadIdSchema, toolIdSchema } from './chat-ids';

export const structuredResponsePayloadSchema = z.object({
    blocks: z.array(chatBlockSchema).min(1),
});

export type StructuredResponsePayload = z.infer<typeof structuredResponsePayloadSchema>;

export const structuredResponseEventSchema = z.object({
    eventId: chatEventIdSchema,
    eventType: z.literal('structured-response'),
    messageId: chatMessageIdSchema,
    payload: structuredResponsePayloadSchema,
    threadId: chatThreadIdSchema,
    timestamp: z.string(),
    toolId: toolIdSchema,
});

export type StructuredResponseEvent = z.infer<typeof structuredResponseEventSchema>;
